import { createSlice } from "@reduxjs/toolkit";
import { fetchDispatch } from "./thunk";

interface DispatchState {
  DispatchList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DispatchState = {
  DispatchList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DispatchSlice = createSlice({
  name: "Dispatch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.DispatchList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Purchase Order";
      });
  },
});

export default DispatchSlice.reducer;
